import { useNuxtApp } from '#imports';
import { callWithNuxt } from '#app/nuxt';
import axios from 'axios';
export default defineNuxtRouteMiddleware((to) => {
    const nuxtApp = useNuxtApp();
    const { status, signIn } = useAuth();

    if (status.value !== 'authenticated') {
        
        return callWithNuxt(nuxtApp, signIn, [
            undefined,
            { callbackUrl: to.path },
            { prompt: 'login' },
        ]);
    }

    const loginlist = [
        'm.kahl',
        'li.schmidt',
        'g.kopka',
        'o.hafsi',
        'm.hauptlorenz',
        'j.motzelt',
        'f.steyer',
        'a.markau',
        'a.morovati',
        'h.fouladikia',
    ];
    const loggeduser = localStorage.getItem('windows_name');

    if (to.meta?.loginRequired && !loginlist.includes(loggeduser)) {
        return navigateTo('/unauthorized');
    }
    const loginbundeslist = [
        'g.kopka',
        'f.steyer',
        'a.markau',
        'h.fouladikia',
        'a.morovati',
        'o.cekmareva',
        'h.knoll',
        'a.tischendorf',
        'o.hecker',
        'b.abraham',
        'm.hollstein',
        'j.sacht',
    ];

    if (to.meta?.Required_bundes && !loginbundeslist.includes(loggeduser)) {
        return navigateTo('/unauthorized');
    }

    const get_fuhrparklist = async () => {
      try {
          const token = sessionStorage.getItem("temp_tok_laravel");
          const { data } = await axios.get(
              ' https://api.tempton-connect.de/api/digital/Fuhrpark_Users',
              {
                  headers: {
                      authorization: `Bearer ${token}`,
                  },
              }
          );
          var loggeduserfuhrlist = localStorage.getItem('windows_name');
          const isFound = data.data.some((element) => {
              if (element.Username === loggeduserfuhrlist) {
                  return true;
              }
              return false;
          });
          if (to.meta?.required_fuhr && !isFound ) {
            return navigateTo('/unauthorized');
          }
      } catch (error) {
          console.error('Error fetching user tree access:', error);
      }
  };
  const transponder_timelogin = async () => {
    try {
        const token = sessionStorage.getItem("temp_tok_laravel");
        const { data } = await axios.get(
            'https://api.tempton-connect.de/api/digital/transponder_time',
            {
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }
        );
        var loggedusertnlist = localStorage.getItem('windows_name');
        const isFound_tn = data.data.some((element) => {
            if (element.Windowsnutzer === loggedusertnlist) {
                return true;
            }
            return false;
        });
        if (to.meta?.required_tn && !isFound_tn ) {
          return navigateTo('/unauthorized');
        }
    } catch (error) {
        console.error('Error fetching user tree access:', error);
    }
};
get_fuhrparklist();
transponder_timelogin();
});
